import PslaModal from './PslaModal';
import PastLossEarningsModal from './PastLossEarningsModal';
import PastServicesModal from './PastServicesModal';
import BereavementAwardModal from './BereavementAwardModal';
import CareModal from './CareModal';
import FuneralExpensesModal from './FuneralExpensesModal';
import MiscModal from './MiscModal';
import DependencyServicesModal from './DependencyServicesModal';
import LossOfIncomeModal from './LossOfIncomeModal';

export default {
    PslaModal,
    PastLossEarningsModal,
    PastServicesModal,
    BereavementAwardModal,
    CareModal,
    FuneralExpensesModal,
    MiscModal,
    DependencyServicesModal,
    LossOfIncomeModal
};


// WEBPACK FOOTER //
// ./src/pages/reserving/day-one/lost/accordian-content/index.js